import { Component, DoCheck, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CostService } from '../../../../service/cost.service';
import { ProviderService } from '../../../../service/provider.service';

@Component({
  selector: 'app-job-cost',
  templateUrl: './job-cost.component.html',
  styleUrls: ['./job-cost.component.less']
})
export class JobCostComponent implements OnInit {
  // 业务类型提示框
  typeTooltip = '请选择';
  @ViewChild('costTypeTreeSelect') costTypeTreeSelect: NzTreeSelectComponent | undefined;
  @Input() cost: any;
  @Input() isEdit = true;
  costForm: FormGroup | undefined;
  costTypes = [];
  providers = [];
  typeMap = new Map<number, any>();
  beforeValue = '';
  value?: string;
  constructor(
    private fb: FormBuilder,
    private costService: CostService,
    private providerService: ProviderService
  ) { }

  async ngOnInit(): Promise<void> {
    this.costForm = this.fb.group({
      money: [!this.isEmpty(this.cost) ? this.cost.money : null, [Validators.required]], // 费用
      costType: [!this.isEmpty(this.cost) ? this.cost.costType : null, [Validators.required]], // 费用类型
      relatedProvideId: [!this.isEmpty(this.cost) ? this.cost.relatedProvideId : null], // 供应商
      costDesc: [!this.isEmpty(this.cost) ? this.cost.costDesc : null]
    });
    this.setFormDisable(this.isEdit);
    const types = await this.costService.getCostTypeList();
    this.costTypes = this.initCostTypeTree(types);
    this.providers = await this.providerService.getProviderList();
  }
  public setFormDisable(isEdit: boolean) {
    if (isEdit) {
      this.costForm.controls.money.enable();
      this.costForm.controls.costType.enable();
      this.costForm.controls.relatedProvideId.enable();
      this.costForm.controls.costDesc.enable();
    } else {
      this.costForm.controls.money.disable();
      this.costForm.controls.costType.disable();
      this.costForm.controls.relatedProvideId.disable();
      this.costForm.controls.costDesc.disable();
    }
  }
  initCostTypeTree(types: any[]) {
    const costTypes = [];
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        costTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    return costTypes;
  }

  treeSelectChanged(key: string) {
    this.fillTypeTooltip(key);
    if (!this.isEmpty(key)) {
      const node = this.costTypeTreeSelect.getTreeNodeByKey(key);
      if (node != null) {
        if (node.isLeaf) {
          this.beforeValue = key;
        } else {
          this.costForm.get('costType').setValue(this.beforeValue);
        }
      }
    }
  }

  fillTypeTooltip(key) {
    if (key !== undefined && key !== null) {
      if (this.costTypeTreeSelect) {
        let currentNode = this.costTypeTreeSelect.getTreeNodeByKey(key);
        if (currentNode != null) {
          // 获取叶子节点完整路径，用于提示框
          let toolTip = `${currentNode.origin.title}`;
          while (currentNode.getParentNode()) {
            currentNode = currentNode.getParentNode();
            toolTip = `${currentNode.origin.title}-->${toolTip}`;
          }
          this.typeTooltip = toolTip;
        }
      }
    }
  }

  public validateCostFormData(costForm: any) {
    // tslint:disable-next-line:forin
    for (const i in costForm.controls) {
      costForm.controls[i].markAsDirty();
      costForm.controls[i].updateValueAndValidity();
    }
    return this.costForm.valid;
  }
  public getCostForm() {
    return this.costForm;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
